import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step4 } from '../../../../../shared/models/component-messages/simp_an/step4';
import { Annulation } from '../../models/Annulation';

@Component({
	selector: 'app-step4',
	templateUrl: './step4.component.html'
})
export class Step4Component implements OnInit {
	@Input() fnSimpleAnnulation: Annulation;
	@Input() parentForm: FormGroup;
	@Input() disabled: boolean;

	@Input() uid = '';
	@Input() linkForRouter: string;

	public step4 = new Step4();

	constructor() {}

	public ngOnInit() {}

	public getUid() {
		return this.uid;
	}
}
